import { Typography } from '@navi/web-ui/lib/primitives';
import EllipsisText from '../EllipsisText';
import { Tooltip, TooltipContent, TooltipTrigger } from '../TooltipV2/TooltipV2';
import styles from './index.module.scss';

interface EllipsisTooltipPlaceholderProps {
  text: string;
  disabled?: boolean;
}

const EllipsisTooltipPlaceholder = (props: EllipsisTooltipPlaceholderProps) => {
  const { text, disabled } = props;

  return (
    <>
      <Tooltip placement="top" hiddenPadding={0} hideStrategy="referenceHidden">
        <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
          <Typography
            variant="p3"
            color={
              disabled
                ? 'var(--navi-bordered-input-hint-text-wrapper-text)'
                : 'var(--navi-color-gray-c1)'
            }
            className={styles['dropdown--title']}
          >
            <EllipsisText text={text} ellipsisWrapperClass="w-full" />
          </Typography>
        </TooltipTrigger>
        <TooltipContent className="tooltipWrapper">{text}</TooltipContent>
      </Tooltip>
    </>
  );
};

export default EllipsisTooltipPlaceholder;
